<template>
  <div>
    <breadcrumb></breadcrumb>

    <div class="row">
      <div class="col">
        <router-link to="/users/new" class="btn btn-success" role="button"
          >Novo</router-link
        >
        <hr />
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="relatorio"
      tabindex="-1"
      aria-labelledby="relatorioLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="relatorioLabel">Gerar relatório</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5>{{ selecionado.login }}</h5>
            <form>
              <div class="row">
                <div class="col">
                  <input
                    v-model="inicio"
                    type="date"
                    class="form-control"
                    placeholder="Data inicio"
                  />
                </div>
                <div class="col">
                  <input
                    v-model="fim"
                    type="date"
                    class="form-control"
                    placeholder="Data fim"
                  />
                </div>
                <div class="col mt-2">
                  <label for="fit">
                    <input v-model="fit" id="fit" type="checkbox" />
                    Fitness
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <a
              target="_blank"
              type="button"
              class="btn btn-primary"
              :href="`${api}/${selecionado._id}/${inicio}/${fim}/${fit}?token=${token}`"
              >Gerar</a
            >
          </div>
        </div>
      </div>
    </div>

    <!--desreset-->
    <div
      class="modal fade"
      id="desreset"
      tabindex="-1"
      aria-labelledby="desresetLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="desresetLabel">Ajustar Reset</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5>Login:{{ selecionado.login }} - Email:{{ selecionado.email }}</h5>
            <form>
              <div class="row">
                <div class="col">
                  <input
                    v-model="inicioRel"
                    type="date"
                    class="form-control"
                    placeholder="Data inicio do relatório"
                  />
                </div>
                <div class="col">
                  <input
                    v-model="mmmRecord"
                    type="text"
                    class="form-control"
                    placeholder="Limite Atual (mmm record)"
                  />
                </div>
              </div>
            </form>
            <div v-show="successMessage" class="row mt-2">
              <div class="col">
                <div class="alert alert-success" role="alert">
                  {{ successMessage }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <a
              class="btn btn-primary"
              href="javascript;"
              @click.prevent="atualizarReset(selecionado._id)"
              >Atualizar</a
            >
          </div>
        </div>
      </div>
    </div>

    <!--modalLink-->
    <div
      class="modal fade"
      id="modalLink"
      tabindex="-1"
      aria-labelledby="modalLinkLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalLinkLabel">
              Gerar Link de acesso
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5>{{ selecionado.login }}</h5>
            <form>
              <div class="row">
                <div class="col">
                  <input
                    v-model="qtdDays"
                    type="text"
                    class="form-control"
                    placeholder="Quantidade de dias"
                  />
                </div>
                <div class="col mt-2">
                  <label for="enviarEmail">
                    <input
                      v-model="enviarEmail"
                      id="enviarEmail"
                      type="checkbox"
                    />
                    Enviar via email
                  </label>
                </div>
              </div>
            </form>
            <div v-show="successMessage" class="row mt-2">
              <div class="col">
                <div class="alert alert-success" role="alert">
                  {{ successMessage }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
                <input type="hidden" id="applink" v-model="applink" />
                <a
                  class="btn btn-primary"
                  href="javascript;"
                  @click.prevent="getAppLink(selecionado._id)"
                  >Link</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="simples"
            v-model="simples"
            @change="start"
          />
          <label class="form-check-label" for="simples">
            Listagem Simples
          </label>
        </div>
        <table class="table table-sm table-striped">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Email</th>
              <th scope="col">MMM Record</th>
              <th v-show="!simples" scope="col">Última Média Calculada</th>
              <th scope="col">Ultimo Input</th>
              <th scope="col">Expira em</th>
              <th scope="col">Bloqueado</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody style="font-size: 10px">
            <tr
              v-for="item in data"
              :key="item._id"
              :class="{ 'text-danger': !item.email }"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.email ? item.email : item.login }}</td>
              <td>{{ item.mmmRecord ? item.mmmRecord : item.mmmRecord }}</td>
              <td v-show="!simples">
                {{ item.ultimaMMM ? item.ultimaMMM.media : "" }}
              </td>
              <td>{{ format(item.ultimoInput) }}</td>
              <td>{{ format(item.expiraEm) }}</td>
              <td>{{ item.blocked ? "SIM" : "NAO" }}</td>
              <td>
                <router-link
                  title="Edit"
                  :to="{ name: 'UsersEdit', params: { id: item._id } }"
                >
                  edit
                </router-link>
                /
                <a
                  href="javascript;"
                  @click.prevent="remove(item._id)"
                  title="Remove"
                  >remove</a
                >
                /
                <a
                  href="javascript;"
                  @click.prevent="modalLink(item)"
                  data-toggle="modal"
                  data-target="#modalLink"
                  >Link</a
                >
                /
                <a
                  href="javascript;"
                  @click.prevent="modalRelatorio(item)"
                  data-toggle="modal"
                  data-target="#relatorio"
                  >Relatório</a
                >
                /
                <a
                  href="javascript;"
                  @click.prevent="modalDesreset(item)"
                  data-toggle="modal"
                  data-target="#desreset"
                  >Desreset</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ls from "local-storage";

export default {
  name: "Users",
  data() {
    return {
      hasSuccess: false,
      simples: true,
      successMessage: "",
      applink: "",
      data: [],
      selecionado: {},
      inicio: "",
      fim: "",
      fit: false,
      enviarEmail: false,
      qtdDays: 7,
      api: `${process.env.API_ENV}/api/v1/historico/gerarAnaliseAlimentar`,
      token: ls("token"),

      mmmRecord: 0,
      inicioRel: '',
    };
  },
  methods: {
    async modalRelatorio(user) {
      this.selecionado = user;
      this.inicio = moment(user.inicioRel ? user.inicioRel : "").format(
        "YYYY-MM-DD"
      );
      this.fim = moment().format("YYYY-MM-DD");
    },
    async modalDesreset(user) {
      this.selecionado = user;
      this.mmmRecord = user.mmmRecord;
      this.inicioRel = moment(user.inicioRel ? user.inicioRel : "").format("YYYY-MM-DD");
    },
    async modalLink(user) {
      this.selecionado = user;
    },
    async getAppLink(id) {
      const tokenReq = await this.$http.post("/v1/usuario/getLink", {
        _id: id,
        qtdDays: this.qtdDays,
        enviarEmail: this.enviarEmail,
      });
      this.applink = `https://app.clinicadometabolismo.com/#/login?token=${tokenReq.data.token}`;

      setTimeout(() => {
        let applinkToCopy = document.querySelector("#applink");
        applinkToCopy.setAttribute("type", "text");
        applinkToCopy.select();

        try {
          var successful = document.execCommand("copy");
          var msg = successful ? "successful" : "unsuccessful";
          console.log("Testing code was copied " + msg);
        } catch (err) {
          console.log("Oops, unable to copy");
        }

        /* unselect the range */
        applinkToCopy.setAttribute("type", "hidden");
        window.getSelection().removeAllRanges();
      }, 100);

      this.hasSuccess = true;
      this.successMessage = "Link copiado";

      setTimeout(() => (this.successMessage = ""), 3000);
    },
    atualizarReset(id) {
      this.$http.put(`/v1/usuario/desreset`, { inicioRel: this.inicioRel, mmmRecord: this.mmmRecord, usuario: id}).then(() => {
        this.hasSuccess = true;
        this.successMessage = "Atualizado!";

        setTimeout(() => (this.successMessage = ""), 3000);
        
        this.start();
      });
    },
    remove(id) {
      this.$http.delete(`/v1/usuario/${id}`).then(() => {
        this.$http.get("/v1/usuario").then((response) => {
          this.data = response.data.data;
          this.$router.push("/users");
        });
      });
    },
    format(d) {
      if (d) {
        return moment(d).format("DD/MM/YYYY HH:mm:ss");
      }

      return;
    },
    start() {
      if (this.simples) {
        this.$http.get("/v1/usuario/simples").then((response) => {
          this.data = response.data.data;
        });
      } else {
        this.$http.get("/v1/usuario").then((response) => {
          this.data = response.data.data;
        });
      }
    },
  },
  beforeMount() {
    this.start();
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/users/UsersHome.vue